import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Loading from '../../components/Loading/Loading';
import styles from './LoadingPage.module.less';
import { logging } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default function LoadingPage() {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'LoadingPage',
        label: '',
        param2: {
          source: 'LoadingPage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);

  return (
    <div className={styles.loading}>
      <Loading />
    </div>
  );
}
